import { BusinessActivityTypeName } from '../../batSchemas/types';

export enum EstimateRunType {
  Bee = 'Bee',
  Vee = 'Vee',
  MoVee = 'MoVee',
}

// split out CEE from EstimateRunType because all "EE"s in EstimateRunType run through the same code path and CEE has its own
export enum CeeEstimateRunType {
  Cee = 'Cee',
}

export const FinanceHoldingTypesList = [
  'corporate_asset_holding',
  'real_estate_asset_holding',
  'asset_group_holding',
  'personal_motor_vehicle_insurance_holding',
  'sovereign_debt_holding',
  'insurance_commercial_line_holding',
  'legacy_finance_emissions',
] as const satisfies ReadonlyArray<BusinessActivityTypeName>;

// We define our finance holding types here so that we can reliably reference
// the string names elsewhere, and be sure they are valid BAT types.
export type FinanceHoldingType = (typeof FinanceHoldingTypesList)[number];

// Names of references data associated with finance assets.  Should match up
// with what we have defined in cliq
// https://github.com/watershed-climate/cliq/tree/main/cliq/domain/finance/rds
export type FinanceAssetRefDataName =
  | 'corporate_asset_properties'
  | 'corporate_asset_emissions_factors'
  | 'real_estate_asset_properties'
  | 'real_estate_asset_emissions_factors'
  | 'asset_group_properties'
  | 'asset_group_emissions_factors'
  | 'personal_motor_vehicle_insurance_emissions_factors'
  | 'corporate_asset_pcaf_5_emissions_factors';

export const FinanceHoldingTypeToAssetString: Record<
  Exclude<FinanceHoldingType, 'legacy_finance_emissions'>,
  string
> = {
  corporate_asset_holding: 'Corporate Asset',
  insurance_commercial_line_holding: 'Corporate Asset',
  real_estate_asset_holding: 'Commercial Real Estate',
  asset_group_holding: 'Asset Group',
  personal_motor_vehicle_insurance_holding: 'Personal Motor Vehicle Insurance',
  sovereign_debt_holding: 'Sovereign Debt',
};
